import Vue from "vue";
import Router from "vue-router";


import LoginPage from './pages/LoginPage';
import PersonList from './pages/PersonList';
import UserProfile from './pages/UserProfile';
import store from './store'
import * as types from './store/types'


Vue.use(Router);

export default new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "persons",
            component: PersonList
        },
        {
            path: "/profile",
            name: "profile",
            component: UserProfile,
            beforeEnter(to, from, next){
                store.dispatch('user/'+types.USER_REQUEST).then(resp => {
                    next()
                })
            }
        },
        {
            path: "/login",
            name: "login",
            component: LoginPage
        }
    ]
});